import { IThemeLoaderConfig } from '@nibtravel/shared/ui/theme';

export const APP_THEMES: IThemeLoaderConfig[] = [
  {
    theme: 'sv',
    load: () =>
      import('@nibtravel/shared/ui/theme/sv-theme').then(
        (m) => m.SvThemeModule
      ),
  },
  {
    theme: 'tidau',
    load: () =>
      import('@nibtravel/shared/ui/theme/tidau-theme').then(
        (m) => m.TidauThemeModule
      ),
  },
];
